import { render, staticRenderFns } from "./LoaderPage.vue?vue&type=template&id=14ee0823&scoped=true"
var script = {}
import style0 from "./LoaderPage.scss?vue&type=style&index=0&id=14ee0823&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ee0823",
  null
  
)

export default component.exports